import { FC } from "react";

interface RatingStarSVGProps {
    className?: string;
    fill?: string;
}

const RatingStarSVG: FC<RatingStarSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="30"
            height="29"
            viewBox="0 0 30 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.8098 0.58541C14.8697 0.401148 15.1303 0.401148 15.1902 0.58541L18.5473 10.9175C18.5741 10.9999 18.6509 11.0557 18.7375 11.0557H29.6014C29.7951 11.0557 29.8757 11.3037 29.7189 11.4175L20.9299 17.8031C20.8598 17.8541 20.8305 17.9443 20.8572 18.0267L24.2144 28.3589C24.2742 28.5431 24.0633 28.6963 23.9066 28.5825L15.1176 22.1969C15.0475 22.1459 14.9525 22.1459 14.8824 22.1969L6.09342 28.5825C5.93667 28.6963 5.72578 28.5431 5.78565 28.3589L9.14276 18.0267C9.16953 17.9443 9.1402 17.8541 9.0701 17.8031L0.281075 11.4175C0.124332 11.3037 0.204887 11.0557 0.398632 11.0557H11.2625C11.3491 11.0557 11.4259 10.9999 11.4527 10.9175L14.8098 0.58541Z"
                fill={props.fill || "#C58811"}
            />
        </svg>
    );
};

export default RatingStarSVG;
